/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { useMainCoreModule } from '../MainCoreModuleProvider';
import { GlobalContextProvider } from '../../../../providers/GlobalContextProvider';
import { PortalSpinner } from '../../../../PortalSpinner';
import { ThemeProvider } from '../../../../providers/ThemeProvider';
import { AppContainer } from '../../../../AppContainer';
import { AppStates } from '../../../../../enums';

export const MainApp: React.FC<{}> = observer(() => {
    const mainCoreModule = useMainCoreModule();

    useEffect(() => {
        if (mainCoreModule.appState === AppStates.Unauthorized) {
            mainCoreModule.resetLoadedData();
        }
        if (mainCoreModule.appState === AppStates.Loading) {
            mainCoreModule.init();
        }
    }, [mainCoreModule.appState]);

    return (
        <GlobalContextProvider coreModule={mainCoreModule}>
            <>
                {mainCoreModule.appState === AppStates.Loading && (
                    <ThemeProvider>
                        <PortalSpinner whiteBg />
                    </ThemeProvider>
                )}

                {mainCoreModule.appState !== AppStates.Loading && (
                    <AppContainer />
                )}
            </>
        </GlobalContextProvider>
    );
});
